module.exports = __webpack_public_path__ + "img/mgs.370a2693.png";